import { Box, Stack, Typography } from "@mui/material";
import PageTitle from "../components/PageTitle";
import { useAuth } from "../../shared/auth/AuthContext";
import { useParams, Navigate } from "react-router-dom";
import BoxCard from "../../shared/components/BoxCard";

export default function DiscordLink() {
  const { user, loading } = useAuth();
  const { id } = useParams();

  if (!id) {
    throw "Invalid Params";
  }

  // If user is not logged in, redirect to login with the magic code
  if (!loading && !user) {
    return <Navigate to={`/login?code=${id}`} replace />;
  }

  if (loading) {
    return <PageTitle title="Loading...." />;
  }

  // User is already logged in
  return (
    <Box>
      <PageTitle title="Discord Login" />
      <BoxCard title="Logged In!">
        <Stack direction="row" alignItems="center">
          <Typography flex={1}>
            You're logged in as Discord user{" "}
            <strong>{user?.username}</strong>!
            <br />
            <br />
            You can close this tab and return to Discord.
          </Typography>
          {user?.avatarUrl && (
            <img
              style={{ marginLeft: 10, maxWidth: 100, maxHeight: 100, borderRadius: "50%" }}
              src={user.avatarUrl}
              alt={user.username}
            />
          )}
        </Stack>
      </BoxCard>
    </Box>
  );
}
